<template>
  <div class="uk-container uk-margin-large-top">
    <h2 class="uk-heading-line"><span>Ürünler</span></h2>
    <div class="uk-grid-small uk-child-width-1-2@s uk-child-width-1-3@m" uk-grid>
     <div class="product-grid">
  <ProductCard
    v-for="product in products"
    :key="product.id"
    :product="product"
  />
</div>
    </div>
  </div>
</template>

<script>
import ProductCard from "@/components/ProductCard.vue";

export default {
  name: "Store",
  components: { ProductCard },
  data() {
    return {
      products: [
        {
          id: 1,
          name: "PT1000 Sensör (Duvar Tipi)",
          shortDescription: "Endüstriyel ortamlarda iç mekân sıcaklık ölçümü için tasarlanmış, muhafazalı PT1000 sensör.",
          image: "/images/products/pt3.jpg"
        },
        {
          id: 2,
          name: "PT1000 Sensör (Daldırma Tipi)",
          shortDescription: "Paslanmaz çelik gövdeye sahip, kablolu daldırma tipi PT1000 sıcaklık sensörü.",
          image: "/images/products/kafali.jpg"
        },
        {
          id: 3,
          name: "Kontrol Panosu",
          shortDescription: "Kontaktör, termik röle ve sinyal ekipmanlarıyla donatılmış özel tasarım kontrol panosu.",
          image: "/images/products/kontrol-panopsu1.png"
        },
        {
          id: 4,
          name: "Elektrostatik Filtre Ünitesi",
          shortDescription: "HVAC sistemleri ve hava temizleyiciler için yüksek voltajlı kompakt elektrostatik filtre ünitesi.",
          image: "/images/products/filtre.jpg"
        }
      ]
    };
  }
};
</script>